import Vue from 'vue';

export default function() {
	Vue.$ofsCrud.addResource({
		name: 'data-type',
		transport: 'davinci',
		options: {
			namespaced: true
		}
	});
}
